import { Component, Input, OnInit } from '@angular/core';
import { ErrorProvider } from '../../providers/error-provider';

@Component({
  selector: 'error-bad-request',
  templateUrl: './bad-request.component.html'
})
export class BadRequestComponent implements OnInit {

  @Input() public title?: string;
  @Input() public description?: string;

  constructor(public errorProvider: ErrorProvider) { }

  ngOnInit(): void {
  }

}